import { Route } from '@angular/router';

// Routes same for more than one role
export const COMMON_AUTHENTICATED_ROUTES: Route[] = [
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./pages/dashboard/dashboard.page').then((m) => m.DashboardPage),
    title: 'Dashboard',
  },
  {
    path: 'questions-library',
    loadComponent: () =>
      import(
        './pages/status-pages/under-construction/under-construction.page'
      ).then((m) => m.UnderConstructionPage),
    data: {
      legacyUrl: '/questions-library',
    },
    title: "We're Building This Page",
  },
  {
    path: 'ir-generator',
    loadComponent: () =>
      import('./pages/ai-assistant/ir-generator/ir-generator.page').then(
        (m) => m.IrGeneratorPage,
      ),
    title: 'IR Generator',
  },
  {
    path: 'download-reports',
    loadComponent: () =>
      import(
        './pages/status-pages/under-construction/under-construction.page'
      ).then((m) => m.UnderConstructionPage),
    data: {
      legacyUrl: '/download-reports',
    },
    title: "We're Building This Page",
  },
  {
    path: 'manage-suppliers',
    loadComponent: () =>
      import(
        './pages/status-pages/under-construction/under-construction.page'
      ).then((m) => m.UnderConstructionPage),
    data: {
      legacyUrl: '/buyer/manage-suppliers',
    },
    title: "We're Building This Page",
  },
  {
    path: 'invoice-operations',
    loadComponent: () =>
      import(
        './pages/status-pages/under-construction/under-construction.page'
      ).then((m) => m.UnderConstructionPage),
    data: {
      legacyUrl: '/invoice-operations',
    },
    title: "We're Building This Page",
  },
];

// only buyer specific roles
export const BUYER_ROUTES: Route[] = [
  {
    path: 'create-surveys',
    loadComponent: () =>
      import(
        './pages/status-pages/under-construction/under-construction.page'
      ).then((m) => m.UnderConstructionPage),
    data: {
      legacyUrl: '/create-surveys',
    },
    title: "We're Building This Page",
  },
  {
    path: 'manage-buyer-settings',
    loadComponent: () =>
      import(
        './pages/status-pages/under-construction/under-construction.page'
      ).then((m) => m.UnderConstructionPage),
    data: {
      legacyUrl: '/buyer/manage-buyer-settings',
    },
    title: "We're Building This Page",
  },
];
